module.exports = __webpack_public_path__ + "img/minimize.7d59ff4f.png";